import * as React from 'react';
import * as opinionsStyle from './opinions.module.scss';
import OpinionData from "../../../data/opinion-data";

const Opinions = () => {
    return (
        <div>
            <p className="text-center mb-4 pb-0" data-sal="slide-down" data-sal-delay="200" data-sal-duration="400">
                <h2 className="bb-primary mb-1 pb-2 d-inline-block ">Opinie naszych Pacjentów</h2>
                <p className="fs-5">Dziękujemy za zaufanie i zapraszamy ponownie!</p>
            </p>
            <div id="carouselOpinionCaptions" className="carousel slide pb-5" data-bs-ride="carousel"
                 data-sal="zoom-in" data-sal-delay="200" data-sal-easing="ease-in-sine" data-sal-duration="300">
                <div className="carousel-indicators">
                    {
                        OpinionData.map((opinion, index) =>
                            <button type="button" data-bs-target="#carouselOpinionCaptions" data-bs-slide-to={index} className={index === 0 ? "active" : ""}></button>
                        )
                    }
                </div>
                <div className="carousel-inner bg-primary rounded">
                    {
                        OpinionData.map((opinion, index) =>
                            <div className={index === 0 ? "carousel-item active" : "carousel-item"} data-bs-interval="5000">
                                <div className={opinionsStyle.opinionBox +" carousel-caption"}>
                                    <i className="bi-chat-left-quote fs-1"></i>
                                    <blockquote className="blockquote">
                                        <p>"{opinion.content}"</p>
                                        <footer className="blockquote-footer">
                                            <cite title={opinion.author}>{opinion.author}</cite>
                                        </footer>
                                    </blockquote>
                                </div>
                            </div>
                        )
                    }
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselOpinionCaptions" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Poprzednia</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselOpinionCaptions" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Następna</span>
                </button>
            </div>
        </div>
    )
}
export default Opinions